<template>
  <div v-if="list.length > 0" class="vtabs">
    <div
      v-for="item in list"
      :key="item.id"
      v-tooltip="item.disabled ? item.disabled_text : ''"
      class="vtab"
      :class="{ selected: item.id === active, disabled: item.disabled }"
      @click="handle_click(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Vtabs',

  props: {
    list: {
      type: [Array],
      default: () => [],
      required: true
    },

    value: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      active: null
    };
  },

  watch: {
    value(val) {
      this.active = val;
    }
  },

  created() {
    this.active = this.value;

    if (!this.active && this.list[0]) {
      this.$emit('warn', 'vtabs component doesn`t have value');
      this.active = this.list[0].id;
    }
  },

  methods: {
    handle_click(item) {
      if (item.disabled) {
        return;
      }

      this.$emit('input', item.id);
      this.active = item.id;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vtabs {
  display: flex;
  width: 100%;
  // border-bottom: 1px solid $grey-lighter;
  margin-top: 6px;
  margin-bottom: 10px;

  .vtab {
    @include mixin-text-header;
    cursor: pointer;
    margin-right: 10px;
    padding: 3px 10px;
    border-bottom: 2px solid transparent;
    transition: all linear 0.4s;

    &.selected {
      border-color: $green;
      transition: all linear 0.4s;
    }

    &.disabled {
      opacity: 0.6;
      cursor: no-drop;
    }
  }
}
</style>
